import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, ModalBody } from '@chakra-ui/react';
import HeaderSideNav from '../HeaderSideNav';
import { containerItemStyle } from '../NavigationMenuMobile.style';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function BusinessSideNav(_ref) {
  var _labels$businessSubNa, _labels$businessSubNa2;
  var onClickHeaderTitle = _ref.onClickHeaderTitle,
    labels = _ref.labels;
  return _jsxs(_Fragment, {
    children: [_jsx(HeaderSideNav, {
      title: labels === null || labels === void 0 || (_labels$businessSubNa = labels.businessSubNav) === null || _labels$businessSubNa === void 0 ? void 0 : _labels$businessSubNa.title,
      onClickTitle: onClickHeaderTitle
    }), _jsx(ModalBody, {
      p: "0",
      "data-testid": "businessSideNav",
      children: (labels === null || labels === void 0 || (_labels$businessSubNa2 = labels.businessSubNav) === null || _labels$businessSubNa2 === void 0 ? void 0 : _labels$businessSubNa2.navOptions) && renderItems(labels.businessSubNav.navOptions)
    })]
  });
  function renderItems(items) {
    if (!items) {
      return;
    }
    return _jsx(_Fragment, {
      children: items.map(option => {
        var _option$url;
        return _jsx(Box, _objectSpread(_objectSpread({}, containerItemStyle), {}, {
          "data-testid": "listItem",
          children: _jsx("a", {
            href: (_option$url = option.url) !== null && _option$url !== void 0 ? _option$url : '/',
            children: option.title
          })
        }), option.title);
      })
    });
  }
}